const topics = [
  { title: '动作电影精选', desc: '硬核打斗 · 燃爆肾上腺素', icon: 'ri-sword-line', color: 'accent' },
  { title: '喜剧电影合集', desc: '欢乐解压 · 笑到停不下来', icon: 'ri-emotion-laugh-line', color: 'primary' },
  { title: '经典电影回顾', desc: '影史佳作 · 百看不厌', icon: 'ri-vip-crown-line', color: 'accent' },
  { title: '科幻大片专区', desc: '震撼视觉 · 脑洞大开', icon: 'ri-rocket-line', color: 'primary' },
  { title: '爱情电影推荐', desc: '甜蜜心动 · 感人至深', icon: 'ri-heart-line', color: 'accent' },
  { title: '悬疑烧脑片单', desc: '反转不断 · 猜不到结局', icon: 'ri-lightbulb-flash-line', color: 'primary' },
  { title: '动画电影天地', desc: '全家欢享 · 童趣无限', icon: 'ri-mickey-line', color: 'accent' },
  { title: '恐怖惊悚专场', desc: '胆大就来 · 惊声尖叫', icon: 'ri-ghost-line', color: 'primary' },
  { title: '纪录片精选', desc: '真实世界 · 拓宽视野', icon: 'ri-global-line', color: 'accent' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            按类型精准分类，快速找到您感兴趣的影片专题
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topics.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group flex items-start gap-4 p-4 md:p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-accent-200/60 hover:bg-background-100/70 transition-all duration-200 cursor-pointer"
            >
              <span className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg ${
                item.color === 'accent'
                  ? 'bg-accent-100 text-accent-600'
                  : 'bg-primary-100 text-primary-600'
              }`}>
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 truncate">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-600 whitespace-nowrap">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}